<template>
  <BaseButton
    :color="color"
    :type="type"
    :size="size"
    :is-disabled="isDisabled"
    @click="handleClick"
  >
    {{ label }}
  </BaseButton>
</template>

<script>
import BaseButton from '../BaseButton.vue'

export default {
  name: 'BaseButtonAction',
  components: { BaseButton },
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: undefined
    },
    type: {
      type: String,
      required: false,
      default: 'raised',
      validator: (value) => ['raised', 'text', 'depressed', 'fab'].includes(value)
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) => ['x-small', 'small', 'medium', 'large', 'x-large'].includes(value)
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    detail: {
      type: Object,
      required: false,
      default: null
    }
  },
  methods: {
    handleClick() {
      if (this.detail) {
        this.$emit('row-detail', { detail: this.detail })
      }
    }
  }
}
</script>
